<mat-dialog-content>
    <section class="w3l-hero-headers-11 p-sticky-md">
      <div class="top-header">
          <div class="d-grid grid-columns-top-3">
              <div class="accounts">
                  <ul>
                    <div class="wrapper doctor-appointment">
                      <div class="form-inner-cont">
                        <h1>{{'Vacation Request' | translate }}</h1>
                      </div>
                    </div>

                  </ul>
              </div>
              <BR>
              <div class="search" style="width: 750px;">
                  <form action="search-results.html" method="get">
                    <label style="width: 5%;"></label>
                      <input id="search1" name="search1" type="number" [(ngModel)]="vacnumber"
                      (keyup)="retriveVacTrans()"  placeholder="Serial" style="width: 14%;">
                      <label style="width: 2%;"></label>
                      <input id="search2" name="search2" type="text" [(ngModel)]="vacnote"
                      (keyup)="retriveVacTrans()" placeholder="Employee Name"  style="width: 45%;">
                     
                  </form>
              </div>
          </div>
      </div>
    </section>

    <table>
      <thead>
          <tr >
              <th style="width: 20%;">{{'Serial' | translate}}</th>
              <th style="width: 60%;">{{'Employee Name' | translate}}</th>
              <th style="width: 35%;">{{'Document Date' | translate}}</th>
              <th style="width: 20%;">{{'Choose' | translate}}</th>
          </tr>
      </thead>
      <tbody>
        <tr *ngFor="let proj of vactransList; let i = index">
              <td data-column="Item ID">{{proj.vacnumber}}</td>
              <td data-column="Item Name">{{proj.vacnote}}</td>
              <td data-column="Item Name">{{proj.vacdate}}</td>
              <td data-column="Choose"><button type="button" class="theme-button btn" name="select" id="select" (click)="SelectVacTrans(proj)">Select</button>
              </td>
          </tr>

      </tbody>
    </table>
    </mat-dialog-content>



